'use strict'

import { create } from 'smbls'
import * as app from './smbls'

create({}, app)
